"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _react = _interopRequireDefault(require("react"));
var _constants = require("./constants");
var _utils = require("./utils");
/* eslint-disable react/jsx-filename-extension */

function preferDefault(module) {
  return module && module["default"] || module;
}
function isCannotFindModuleError(error) {
  return error.toString().indexOf('Error: Cannot find module') !== -1;
}
function isPagePath(path, rootSlug) {
  var cleanedSlug = (0, _utils.removeSlugSlashes)(rootSlug);
  return path.includes(cleanedSlug) && !path.endsWith("/".concat(cleanedSlug, "/"));
}
var Layout;
try {
  // eslint-disable-next-line global-require, no-undef, import/no-dynamic-require
  Layout = preferDefault(require(LAYOUT_COMPONENT_PATH));
} catch (e) {
  if (isCannotFindModuleError(e)) {
    // eslint-disable-next-line no-undef
    throw new Error("Couldn't find layout component at \"".concat(LAYOUT_COMPONENT_PATH, "\"."));
  }
}

// eslint-disable-next-line consistent-return
module.exports = function wrapPage(_ref, _ref2) {
  var element = _ref.element,
    props = _ref.props;
  var layoutComponent = _ref2.layoutComponent,
    queryName = _ref2.queryName,
    rootSlug = _ref2.rootSlug,
    instanceId = _ref2.instanceId;
  var _props$location = props.location,
    location = _props$location === void 0 ? {} : _props$location,
    _props$pageContext = props.pageContext,
    pageContext = _props$pageContext === void 0 ? {} : _props$pageContext;
  var pagePluginInstanceId = pageContext.pluginInstanceId;
  var _location$pathname = location.pathname,
    pathname = _location$pathname === void 0 ? '' : _location$pathname;
  var isWrappedPagePath = isPagePath(pathname, rootSlug || _constants.DEFAULT_ROOT_SLUGS[queryName]);
  var isPagePluginInstance = instanceId === pagePluginInstanceId;
  if (isWrappedPagePath && layoutComponent && isPagePluginInstance) {
    return /*#__PURE__*/_react["default"].createElement(Layout, props, element);
  }
};